export enum UiState {
    Inactive = 'INACTIVE',
    InFlight = 'IN_FLIGTH',
    Success = 'SUCCESS',
    Error = 'ERROR',
}

export interface Error {
    code: string;
    message: string;
    errors?: any;
}
